import * as React from 'react';

type Props = {
  children?: React.ReactNode;
};

const Layout = ({ children }: Props) => <>{children}</>;

export default Layout;
